import React from "react";
import { Helmet } from "react-helmet";

import Header from "./Header";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen" style={{ background: "var(--bg-page)" }}>
      <Helmet>
        <title>Politique de confidentialité | Fold Web Agency</title>
        <meta
          name="description"
          content="Politique de confidentialité de Fold Web Agency : données collectées, finalités, durée de conservation, droits RGPD et sécurité."
        />
        <link
          rel="canonical"
          href="https://fold-web-agency.fr/politique-de-confidentialite"
        />
      </Helmet>
      <Header />

      <section className="section">
        <div className="container max-w-4xl">
          <div className="bg-white rounded-xl shadow-sm p-8 md:p-12">
            <div className="container max-w-4xl mx-auto">
              <h1 className="heading-1 mb-6">Politique de confidentialité</h1>

              <p className="body-medium mb-6">
                Cette politique de confidentialité décrit la manière dont{" "}
                <strong>Fold Web Agency</strong> collecte et utilise les données
                personnelles de ses visiteurs et clients, conformément au RGPD et à
                la loi Informatique et Libertés.
              </p>

              <p className="body-medium mb-8">
                La présente politique est applicable exclusivement au site{" "}
                <strong>https://fold-web-agency.fr</strong>.
              </p>

              <h2 className="heading-2 mt-10 mb-4">
                1. Responsable du traitement et hébergement
              </h2>

              <div className="overflow-x-auto">
                <table className="w-full border border-gray-200 text-sm">
                  <tbody>
                    <tr>
                      <td className="border px-4 py-2 font-semibold">Nom et statut</td>
                      <td className="border px-4 py-2">Patrice Tord</td>
                    </tr>
                    <tr>
                      <td className="border px-4 py-2 font-semibold">Adresse postale</td>
                      <td className="border px-4 py-2">
                        44 bis Boulevard de la République, 93130 Noisy-le-Sec
                      </td>
                    </tr>
                    <tr>
                      <td className="border px-4 py-2 font-semibold">Coordonnées</td>
                      <td className="border px-4 py-2">contact@fold-web-agency.fr</td>
                    </tr>
                    <tr>
                      <td className="border px-4 py-2 font-semibold">Numéro SIRET</td>
                      <td className="border px-4 py-2">81927317800023</td>
                    </tr>
                    <tr>
                      <td className="border px-4 py-2 font-semibold">Hébergeur</td>
                      <td className="border px-4 py-2">
                        OVH SAS - 2 rue Kellermann, 59100 Roubaix, France
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h2 className="heading-2 mt-10 mb-4">
                2. Données collectées et finalités
              </h2>

              <ul className="list-disc pl-6 body-medium space-y-2">
                <li>
                  <strong>Formulaire de contact :</strong> nom, email, téléphone,
                  message, utilisés uniquement pour répondre à votre demande.
                </li>
                <li>
                  <strong>Espace client et tickets :</strong> nom, email, entreprise,
                  contenu des demandes, historique de statut et pièces jointes sont
                  traités pour assurer le suivi du support et des interventions.
                </li>
                <li>
                  <strong>Aucun tracking :</strong> aucun outil de mesure d'audience
                  ou de publicité n'est utilisé.
                </li>
              </ul>

              <h2 className="heading-2 mt-10 mb-4">
                3. Durée de conservation
              </h2>

              <ul className="list-disc pl-6 body-medium space-y-2">
                <li>Données de contact : 3 ans après le dernier échange</li>
                <li>Données de tickets support : 3 ans après le dernier échange</li>
                <li>Données de facturation : 10 ans (obligation légale)</li>
              </ul>

              <h2 className="heading-2 mt-10 mb-4">4. Vos droits</h2>

              <p className="body-medium mb-4">
                Vous disposez des droits d'accès, de rectification, d'effacement, de
                limitation, d'opposition et de portabilité de vos données.
              </p>

              <p className="body-medium mb-4">
                Pour exercer ces droits, contactez :
                <strong> contact@fold-web-agency.fr</strong>
              </p>

              <p className="body-medium">
                Vous pouvez également introduire une réclamation auprès de la CNIL.
              </p>

              <h2 className="heading-2 mt-10 mb-4">
                5. Cookies et sécurité
              </h2>

              <p className="body-medium">
                Le site utilise uniquement des cookies techniques nécessaires à son
                fonctionnement. Aucune donnée n'est utilisée à des fins publicitaires
                ou statistiques.
              </p>

              <p className="italic text-gray-500 mt-10">
                Dernière mise à jour : 18 avril 2026
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
